import React, { useEffect, useState } from 'react'
import SchedulesHomeNavigation from './SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../UIElements/SearchByLeagueOrVenue'
import FullSchedule from '../../schedule/FullSchedule'
import LiveScoreTicker from '../../schedule/LiveScoreTicker'
import Banner from './Banner'

const SchedulesHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])
	return (
		<div style={{ overflowX: 'hidden' }}>
			<SchedulesHomeNavigation />

			{/* Reserve space for the fixed 4rem navigation bar */}
			<div style={{ height: '4rem' }} />

			<LiveScoreTicker />
			{!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)}
			<SearchByLeagueOrVenue />
			<FullSchedule />
		</div>
	)
}

export default SchedulesHome
